import { fetchMetrics } from '../helpers';

const getLineId = breadCrumb => {
  const bc = breadCrumb[1] || breadCrumb[0] || [{ id: 0 }];
  return bc.id;
};

export const facebookInit = configuration => {
  const facebookKey = configuration.facebook;
  document.addEventListener('page:load', ({ detail }) => {
    if (!facebookKey) {
      return false;
    }
    fetchMetrics(`https://www.facebook.com/tr?id=${facebookKey}&ev=PageView`);

    try {
      const { page, product, mainOffer, offers } = detail;
      if (!page && !product) {
        return false;
      }
      const { type, breadCrumb } = page;
      if (type === 'product') {
        const offer = mainOffer || offers[0];
        const url = `https://www.facebook.com/tr?id=${facebookKey}&ev=ViewContent&cd[content_name]=${
          product.name
        }&cd[content_category]=${breadCrumb.reduce(
          (acc, next) => (!acc ? next.name : `${acc} > ${next.name}`),
          ''
        )}&cd[content_line]=${getLineId(breadCrumb)}&cd[content_ids]=${product.id}&cd[value]=${
          offer.salesPrice
        }&cd[content_type]=Product&cd[currency]=BRL&cd[content_avaliable]=1`;

        fetchMetrics(url);
      }
    } catch (e) {
      console.warn('FBPIXEL', e);
    }
  });
};
